import type { ReactNode } from 'react';

export const symbol_nest_wifi_pro: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M515.5-304.5Q530-319 530-340t-14.5-35.5Q501-390 480-390t-35.5 14.5Q430-361 430-340t14.5 35.5Q459-290 480-290t35.5-14.5ZM360-80q-75 0-121.5-41T166-223q-27-60-36.5-129.5T120-479q0-100 16-175t57-125q42-51 111-76t176-25q107 0 176 25t111 76q41 50 57 125t16 175q0 57-9.5 126.5T794-223q-26 61-72.5 102T600-80H360Zm0-60h240q58 0 92.5-36.5T747-267q20-54 26.5-112t6.5-100q0-87-11.5-151T723-737q-33-42-91.5-62.5T480-820q-93 0-151.5 20.5T237-737q-34 43-45.5 107T180-479q0 42 6.5 100T213-267q20 54 54.5 90.5T360-140Zm120-340Z"
		/>
	</svg>
);
